var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.625,
    y: 6.125,
    width: 33,
    height: 33,
    rx: 5,
    stroke: "#375DFB",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.625,
    y: 13.125,
    width: 37,
    height: 37,
    rx: 7,
    fill: "#2342BF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5527 25.7725L22.2904 39.4525C21.8679 40.0189 21.2056 40.3549 20.5 40.3645C19.7991 40.3741 19.1271 40.0573 18.6856 39.5101L14.1256 33.8077C13.3383 32.8237 13.4967 31.3885 14.4807 30.6061C15.4648 29.8189 16.9 29.9773 17.6871 30.9613L20.4087 34.3597L28.9 23.0365C29.6583 22.0285 31.0887 21.8269 32.0967 22.5805C33.1 23.3341 33.3063 24.7645 32.5527 25.7725Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.7ba37bf4e74ece6421f5d285095a72d8.svg";
export { ForwardRef as ReactComponent };